// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"3fee2c18","852":"e07d65d7","935":"4b33903f"}[chunkId] + ".chunk.js";
};